/* unplugin-vue-components disabled */import { render } from "./LogicalTransformerSectorAnimate.vue?vue&type=template&id=76a7c8d6&scoped=true"
import script from "./LogicalTransformerSectorAnimate.vue?vue&type=script&lang=js"
export * from "./LogicalTransformerSectorAnimate.vue?vue&type=script&lang=js"

import "./LogicalTransformerSectorAnimate.vue?vue&type=style&index=0&id=76a7c8d6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76a7c8d6"]])

export default __exports__